import type {ColumnsSetting} from '../types/Api';
import type {EagColumnState} from '../types/EagColumnState';

/**
 * Forces `visible: false` on preset column settings whose column is definition-hidden
 * (lockedHidden). Presets saved before a column became definition-hidden may still say
 * `visible: true`; the store force-hides such columns on apply, so any comparison
 * between a saved preset and live columnStates (virtual-preset PUT baseline,
 * custom-preset dirty check) must clamp the saved side the same way — otherwise the
 * stale flag reads as a permanent diff.
 */
export const clampSettingsToLockedHidden = (
  settings: ColumnsSetting[],
  columnStates: EagColumnState[]
): ColumnsSetting[] => {
  const lockedKeys = new Set(
    columnStates.filter((cs) => cs.lockedHidden === true).map((cs) => cs.key)
  );
  if (lockedKeys.size === 0) {
    return settings;
  }
  return settings.map((setting) =>
    setting.visible && lockedKeys.has(setting.columnKey) ? {...setting, visible: false} : setting
  );
};
